

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');


    /*
    $('.carousel.full-height .slick').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        arrows: false
    });
     */

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        autoplay:true,
        autoplaySpeed:3000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

    $('.video-link').lightGallery();

});
